export default "__VITE_ASSET__CmR97hJL__"